export default __webpack_public_path__ + "static/media/header.f171e0d9.png";